export const API_URL = process.env.REACT_APP_API_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;
export const API_PREFIX = process.env.REACT_APP_API_PREFIX;
export const AUTH_API = process.env.REACT_APP_AUTH_API;
export const ROOT_API = '/v1/masterdata';
export const MOCK_API = 'https://4b34f70d-ef8b-47ed-a378-68012a9f3e7c.mock.pstmn.io'